import React, { FC } from 'react';
import clsx, { ClassValue } from 'clsx';

interface ISvg {
  className?: ClassValue;
}


export const SvgFlower: FC<ISvg> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(className, 'fill-current')}
    viewBox="0 0 19 20"
    fill="none"
  >
    <g clip-path="url(#clip0_380_2578)">
      <path
        d="M17.4002 6.13822C16.6839 5.4223 15.7909 4.92114 14.8135 4.6872C14.5798 3.71034 14.0791 2.81726 13.3626 2.10061C12.3306 1.06878 10.9589 0.500488 9.50007 0.500488C8.03889 0.50123 6.66681 1.06989 5.63721 2.10135C4.92093 2.81578 4.42065 3.70926 4.18742 4.68791C3.20855 4.92114 2.31548 5.42156 1.60105 6.13751C0.569406 7.16745 0.000556641 8.53953 0 10.0009C0.000742187 11.4604 0.566475 12.8296 1.59333 13.8566C2.31221 14.5755 3.20788 15.0781 4.1869 15.3132C4.42047 16.2907 4.92163 17.1849 5.63921 17.9023C6.66974 18.9331 8.04071 19.5006 9.49955 19.5003C10.9583 19.5003 12.3352 18.9268 13.3766 17.8853C14.0852 17.1768 14.5808 16.2886 14.8129 15.3124C15.7904 15.0788 16.6832 14.5787 17.3987 13.8632C18.4302 12.8317 18.9992 11.4597 19 9.99978C18.9989 8.54027 18.4309 7.16893 17.4002 6.13822ZM4.85669 5.2116L4.8748 5.11047C4.88107 5.07392 4.88771 5.03885 4.89454 5.00456C5.07946 4.10893 5.52191 3.29111 6.17422 2.63869C7.06284 1.75004 8.24411 1.26071 9.50033 1.26071C10.7566 1.26071 11.9375 1.74966 12.8255 2.63795C13.3632 3.17567 13.7635 3.83584 13.9893 4.55584C13.8395 4.54329 13.6878 4.53739 13.5369 4.53702C12.0764 4.53814 10.7042 5.10643 9.67289 6.13755C8.67888 7.13171 8.11148 8.45395 8.07571 9.85632L8.07481 9.87035C8.07222 9.91317 8.06962 9.95592 8.06943 10.0002C8.06943 10.1604 8.09637 10.3191 8.14822 10.4689C7.40425 10.2456 6.72559 9.84081 6.17426 9.28947C5.28597 8.40122 4.79683 7.22029 4.79683 5.9641C4.79691 5.71309 4.81687 5.45993 4.85669 5.2116ZM4.50519 14.6058C3.60636 14.419 2.78528 13.974 2.13045 13.3193C1.2468 12.4355 0.76 11.2571 0.76 10.0009C0.76 8.74475 1.24955 7.56344 2.13817 6.67478C2.67622 6.13636 3.33643 5.73632 4.05509 5.51122C4.04273 5.66214 4.03665 5.81385 4.03665 5.96406C4.03646 7.42283 4.60475 8.79454 5.6368 9.82674C6.64043 10.8301 7.97336 11.3981 9.38251 11.4247C9.42051 11.428 9.45981 11.4302 9.49855 11.4302C9.65894 11.4306 9.81795 11.4036 9.96799 11.352C9.74455 12.0971 9.33987 12.7757 8.78947 13.3263C7.90137 14.2142 6.71991 14.7035 5.46261 14.7035C5.1755 14.7035 4.89061 14.6781 4.6177 14.6287L4.50519 14.6058ZM14.1269 14.8885C14.1208 14.9213 14.1141 14.9549 14.1058 14.9959C13.9224 15.89 13.4844 16.7034 12.8393 17.3484C11.9418 18.2459 10.7557 18.7401 9.49955 18.7405C8.24337 18.7405 7.06318 18.2519 6.17634 17.3651C5.63755 16.8263 5.23658 16.1653 5.01092 15.4453C5.16076 15.4575 5.31224 15.4638 5.46298 15.4638C6.92346 15.4631 8.29554 14.8947 9.32681 13.8633C10.3227 12.8676 10.8899 11.542 10.9236 10.1342C10.9275 10.0895 10.9294 10.0449 10.9294 10.0009C10.9297 9.84077 10.9031 9.68172 10.8515 9.5315C11.5943 9.75404 12.2704 10.1566 12.8179 10.7039C13.711 11.597 14.2029 12.7805 14.2029 14.0367C14.2029 14.3201 14.1773 14.6069 14.1269 14.8885ZM16.8614 13.3263C16.3241 13.8636 15.6639 14.2637 14.9439 14.4891C14.9561 14.3397 14.9624 14.1883 14.9624 14.0374C14.9624 12.5779 14.3916 11.2032 13.355 10.1666C12.3634 9.17495 11.0425 8.60996 9.6294 8.57527C9.58643 8.57271 9.54346 8.57014 9.49859 8.57014C9.3388 8.57048 9.18049 8.59742 9.0312 8.64874C9.25445 7.90437 9.65909 7.22571 10.2101 6.67475C11.0984 5.7865 12.2797 5.29713 13.5361 5.29751C13.8234 5.29825 14.1118 5.32445 14.3957 5.3761C14.4289 5.38126 14.462 5.38794 14.4946 5.39492C15.3923 5.58091 16.2112 6.02377 16.8633 6.67549C17.7508 7.563 18.2398 8.74393 18.2398 10.0001C18.2398 11.2563 17.7505 12.4373 16.8614 13.3263Z"
        fill="#1C274C"
      />
    </g>
    <defs>
      <clipPath id="clip0_380_2578">
        <rect width="19" height="19" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const SvgOral: FC<ISvg> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(className, 'fill-current')}
     viewBox="0 0 19 20"
    fill="none"
  >
    <rect width="19" height="19" transform="translate(0 0.5)" fill="white" />
    <path
      d="M2.37377 5.5C2.62286 4.95366 2.97429 4.44184 3.42806 3.99293C5.44013 2.00236 8.70235 2.00236 10.7144 3.99293L15.572 8.79858C16.3449 9.56328 16.8209 10.5105 17 11.5M2 8.50001C2.17909 9.48948 2.6551 10.4367 3.42806 11.2014L8.28562 16.0071C10.2977 17.9976 13.5599 17.9976 15.572 16.0071C16.0258 15.5582 16.3771 15.0464 16.6263 14.5"
      stroke="#1D1A19"
      stroke-linecap="round"
    />
    <path
      d="M13 6.5C13 6.5 12.6061 8.54337 10.3246 10.8249C8.04303 13.1064 6 13.5 6 13.5"
      stroke="#1D1A19"
    />
  </svg>
);


export const SvgOil: FC<ISvg> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(className, 'fill-current')}
    viewBox="0 0 19 20"
    fill="none"
  >
    <g clip-path="url(#clip0_376_1916)">
      <path
        d="M9.47046 19.4755C5.88361 19.4755 2.96533 16.597 2.96533 13.0594C2.96533 8.92751 8.74786 1.09476 8.99368 0.762851C9.1053 0.613226 9.27986 0.524163 9.4663 0.522976C9.67352 0.521195 9.82908 0.608476 9.94249 0.75632C10.1913 1.08169 16.035 8.7761 16.035 13.0594C16.035 16.5976 13.09 19.4755 9.47046 19.4755ZM9.47699 2.12669C8.09652 4.08726 4.15283 9.95766 4.15283 13.0594C4.15283 15.9421 6.53852 18.288 9.47046 18.288C12.435 18.288 14.8475 15.9427 14.8475 13.0594C14.8475 9.84247 10.8741 4.05994 9.47699 2.12669Z"
        fill="#1C274C"
      />
    </g>
    <defs>
      <clipPath id="clip0_376_1916">
        <rect width="19" height="19" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);


export const SvgTopical: FC<ISvg> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(className, 'fill-current')}
    viewBox="0 0 21 22"
    fill="none"
  >
    <g clip-path="url(#clip0_376_1927)">
      <path
        d="M12.9579 6.75278H12.0641V5.85901C12.0641 5.61321 11.863 5.41211 11.6172 5.41211H9.38279C9.13699 5.41211 8.93589 5.61321 8.93589 5.85901V6.75278H8.04212C7.79632 6.75278 7.59521 6.95388 7.59521 7.19969V9.43413C7.59521 9.67993 7.79632 9.88103 8.04212 9.88103H8.93589V10.7748C8.93589 11.0206 9.13699 11.2217 9.38279 11.2217H11.6172C11.863 11.2217 12.0641 11.0206 12.0641 10.7748V9.88103H12.9579C13.2037 9.88103 13.4048 9.67993 13.4048 9.43413V7.19969C13.4048 6.95388 13.2037 6.75278 12.9579 6.75278ZM12.511 8.98726H11.6173C11.3715 8.98726 11.1704 9.18836 11.1704 9.43417V10.3279H9.8297V9.43417C9.8297 9.18836 9.6286 8.98726 9.38279 8.98726H8.48902V7.64659H9.38279C9.6286 7.64659 9.8297 7.44549 9.8297 7.19969V6.30592H11.1704V7.19969C11.1704 7.44549 11.3715 7.64659 11.6173 7.64659H12.511V8.98726Z"
        fill="#1C274C"
      />
      <path
        d="M16.0148 0.750859C15.845 0.581055 15.6126 0.491649 15.3757 0.500615H5.62456C5.38773 0.491691 5.15533 0.585538 4.98552 0.750859C4.78442 0.956443 4.68609 1.26031 4.69058 1.67592C4.79783 11.3064 6.64348 16.3965 6.92502 17.116V20.0789C6.92502 20.414 7.17974 21.5 10.4689 21.5C13.8161 21.5 14.0753 20.3783 14.0753 20.0387V17.1205C14.3613 16.3965 16.2025 11.3422 16.3097 1.67592C16.3142 1.25583 16.2204 0.95196 16.0148 0.750859ZM10.4689 20.6062C8.56512 20.6062 7.91711 20.204 7.81883 20.0431V17.478H13.1815L13.186 20.0074C13.1815 20.0163 12.8598 20.6062 10.4689 20.6062ZM15.416 1.667C15.3221 10.4171 13.7401 15.4044 13.32 16.5842H7.68028C7.26018 15.3999 5.67819 10.3992 5.58434 1.66252C5.57986 1.4346 5.62456 1.37649 5.62456 1.3899L15.3757 1.37201C15.3757 1.37201 15.4204 1.4346 15.416 1.667Z"
        fill="#1C274C"
      />
    </g>
    <defs>
      <clipPath id="clip0_376_1927">
        <rect width="21" height="21" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const SvgVape: FC<ISvg> = ({ className }) => (
  <svg width="19" height="30" viewBox="0 0 19 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="19" height="29" transform="translate(0 0.5)" fill="white" />
    <path
      d="M3 18.1667C3 15.5893 5.18254 13.5 7.875 13.5H11.125C13.8175 13.5 16 15.5893 16 18.1667V27.5H3V18.1667Z"
      stroke="#1C274C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 7.5H7V13.5H12V7.5Z"
      stroke="#1C274C"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M10 7.5V2.5" stroke="#1C274C" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M10 21.5V13.5" stroke="#1C274C" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export const SvgEnvelope: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className, 'fill-current')}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.60156 4.20114C2.14978 3.47258 3.02139 3 3.99981 3H19.9998C20.9782 3 21.8498 3.47258 22.398 4.20113L11.9998 11.7635L1.60156 4.20114Z"
      fill="currentColor"
    />
    <path
      d="M1 6.23634V17.9998C1 19.6521 2.34772 20.9998 4 20.9998H20C21.6523 20.9998 23 19.6521 23 17.9998V6.23633L13.1763 13.3808C12.475 13.8908 11.525 13.8908 10.8237 13.3808L1 6.23634Z"
      fill="currentColor"
    />
  </svg>
);

export const SvgChat: FC<ISvg> = ({ className }) => (
  <svg
    className={clsx(className)}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 7.5C10.5 7.76522 10.3946 8.01957 10.2071 8.20711C10.0196 8.39464 9.76522 8.5 9.5 8.5H3.5L1.5 10.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H9.5C9.76522 1.5 10.0196 1.60536 10.2071 1.79289C10.3946 1.98043 10.5 2.23478 10.5 2.5V7.5Z"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);